export const NOTIFICATION_EVENTS = '/admin/app/notification-events';
export const NOTIFICATION_TEMPLATES = '/admin/app/notification-templates';

//Profile
export const MY_PROFILE = '/my-profile';
export const All_NOTIFICATION = '/notification/list';
export const LOGOUT = '/admin/log-out';
export const ADMIN_DASHBOARD = '/admin/dashboard';

//app setting view
export const APP_SETTINGS = '/app-setting';
export const BASIC_GENERAL_SETTINGS = 'basic-general-setting';
export const GENERAL_SETTINGS = 'general-settings';

//reCAPTCHA
export const GET_RECAPTCHA_SETTINGS = '/get-re-captcha-setting';
//Sms settings
export const GET_SMS_SETTINGS_INFO = 'get-sms-setting-info';
//Email settings
export const GET_EMAIL_SETTINGS = '/admin/app/settings/delivery-settings';
//Broadcast settings
export const BROADCAST_SETTINGS = '/broadcast-setting';

//Update
export const APP_UPDATE = '/app/updates';
export const APP_UPDATE_INSTALL = '/app/updates/install';

//Install
export const GET_UPDATE_URL = '/app/generated-update-url-purchase-code';
export const CLEAR_CACHE= '/app/clear-cache';

//DataTable
export const DATATABLE_DATA = 'example-table';
export const STATUSES = 'admin/app/statuses';

//Custom TAble
export const CUSTOM_TABLE = 'admin/app/custom-tables';

//roles and users
export const ROLES = 'admin/auth/roles';
export const USERS = 'admin/auth/users';
export const GET_USERS = 'exist/users';
export const GET_STATUSES = 'admin/app/statuses';
export const INVITE_USER = '/admin/auth/users/invite-user';
export const DETACH_ROLES = 'admin/auth/users/detach-roles/';
export const UPDATE_USER_NAME = '/update-user-name/';

//Notification
export const NOTIFICATIONS = 'admin/user/notifications';
export const AUTHENTICATE_USER = '/admin/authenticate-user';

// Language
export const LANGUAGE = '/admin/languages';

// test mail
export const TEST_MAIL = `/app/test-mail/send`;

// Social links
export const CHANGE_SOCIAL_LINKS = '/application-api/change-social-link';

// teams
export const TEAMS = `/application-api/teams`;
export const SELECTABLE_TEAMS = `/application-api/selectable/teams`;

// client
export const PROFILE_PICTURE_CHANGE = `/admin/auth/users/profile-picture`;
export const COVER_PICTURE_CHANGE = `admin/auth/users/cover-picture`;
export const USER_TEAMS = `/application-api/selectable/user-teams/`;
export const SEARCH = `/application-api/selectable/feed-search/`;

export const USER_TEAMMATES = `/application-api/selectable/related-users/`;
export const USER_GALLERY = `/application-api/selectable/user-galleries/`;

// posts
export const POSTS = `/application-api/posts`;
export const POST_FEED = `/application-api/post-feed`;
export const POST_COMMENT = `/application-api/posts/`;
export const REPLY_COMMENT = `/application-api/post-comments/`;
export const COMMENT_REPLIES = `/application-api/comment-replies/`;


